import checkIcon from "@icons/check.svg";
import loaderSpinnerIcon from "@icons/loader-spinner.svg";

const quickBuyBtn = {
    /**
     * Add a product to the basket from a quick-buy button click.
     *
     * @param {HTMLElement} el - The quick-buy button element that was clicked.
     * @returns {void}
     */
    addToBasket(el) {
        const slug = /** @type {string} */ (el.dataset.productSlug);
        const productId = el.dataset.searchTrackId
            ? Number(el.dataset.searchTrackId)
            : undefined;
        const track = Number(el.dataset.track);

        el.style.width = `${el.offsetWidth}px`;
        el.innerHTML = `<img src="/img/null.png" width="1" height="1" style="--svg: url(${loaderSpinnerIcon}); --color-icon: var(--color-white); --iconSize: 14px;" alt="" class="lux-svg-icon "></img>`;

        const onDone = (/** @type {any} */ result) => {
            const added = Array.isArray(result?.ids) && result.ids.length > 0;

            el.innerHTML = added
                ? `<img src="${checkIcon}" alt="" class="svg-filter-white" style="height: 9px;">`
                : window.TEXT530;

            if (added) {
                setTimeout(() => {
                    el.innerHTML = window.TEXT530;
                }, 5000);
            }
        };

        // Search results only expose the numeric product ID (their slug can be
        // the numeric product-ID redirect, which does not resolve as a slug), so
        // add those by ID. Everything else still adds by slug.
        if (productId) {
            basket.addProductById(productId, 1, onDone);
        } else {
            basket.addProduct(slug, 1, onDone);
        }

        if (track === 1) {
            fetch(`/tracking/google/quick-add-to-cart/${slug}`)
                .then((response) => response.json())
                .then((data) => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(data);
                });
        }
    },
};

document.addEventListener("click", (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const button = target.closest("button.quick-buy-btn");

    if (button instanceof HTMLElement) {
        quickBuyBtn.addToBasket(button);
    }
});

export {};
